export default "__VITE_ASSET__d6067afe__"